import { API_URL } from "../Util/constant";
import { STORAGE_KEYS } from "../Util/key_helper";

export async function makeGetApiRequest(path) {
	try {
		const response = await fetch(`${API_URL}${path}`, {
			headers: { Authorization: localStorage.getItem(STORAGE_KEYS.FX_USER_ACCESS_TOKEN) },
		});
		if (response.status === 401) {
			localStorage.removeItem(STORAGE_KEYS.FX_USER_ACCESS_TOKEN);
			window.location.href = "/platform/login";
		}
		let ret_data = await response.json();
		return ret_data;
	} catch (error) {
		console.error(error);
		return {
			error: {
				title: "Api request error",
				message: "Api request error",
				error: error,
			},
		};
	}
}

export async function makeApiRequest(path, params) {
	try {
		var reqHeader = new Headers();
		reqHeader.append(
			"Authorization",
			localStorage.getItem(STORAGE_KEYS.FX_USER_ACCESS_TOKEN)
		);
		// If params is already a string (JSON), use as is; otherwise stringify
		const bodyPayload = typeof params === 'string' ? params : JSON.stringify(params);
		reqHeader.append("Content-Type", "application/json");
		const response = await fetch(`${API_URL}${path}`, {
			method: "POST",
			body: bodyPayload,
			headers: reqHeader,
			// mode:'no-cors',
			redirect: "follow",
		});
		const rresponse = await response.json();
		if (response.status === 401) {
			localStorage.removeItem(STORAGE_KEYS.FX_USER_ACCESS_TOKEN);
			window.location.href = "/platform/login";
		}
		if (!rresponse.error) {
			return { result: rresponse };
		} else {
			return { error: rresponse.error.data };
		}
	} catch (error) {
		console.error(error);
		return {
			error: {
				title: "Api request error",
				message: "Api request error",
				error: error,
			},
		};
	}
}
export async function makeFormDataRequest(path, data) {
	const formData = new FormData();

	// Append all key-value pairs from data to FormData
	Object.entries(data).forEach(([key, value]) => {
		formData.append(key, value);
	});

	try {
		var reqHeader = new Headers();
		reqHeader.append("Authorization", localStorage.getItem(STORAGE_KEYS.FX_USER_ACCESS_TOKEN));

		const response = await fetch(`${API_URL}${path}`, {
			method: "POST",
			body: formData,
			headers: reqHeader,
			redirect: "follow",
		});
		if (response.status === 401) {
			localStorage.removeItem(STORAGE_KEYS.FX_USER_ACCESS_TOKEN);
			window.location.href = "/platform/login";
		}
		const jsonResponse = await response.json();
		return jsonResponse;

	} catch (error) {
		console.error(error);
		return { status: false, msg: "API request error", error: error };
	}
}
//-------------------------------------------------------------- ACCOUNT --------------------------------------------------------------
//V1 - GET ACCOUNT PLAN 
export async function GetAccountPlan() {
	const response = await makeGetApiRequest("/users/broker/getbrokerplans");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET ACCOUNT
export async function GetAccounts() {
	const response = await makeGetApiRequest("/users/broker/getbrokers");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//V1 - GET ACCOUNT NAMES
export async function GetAccountNames(payload) {
	const response = await makeApiRequest("/users/broker/getbrokernames", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - ADD ACCOUNT 
export async function AddAccount(values) {
	const response = await makeApiRequest("/users/broker/addbroker", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - RECONNECT ACCOUNT
export async function ReconnectAccount(values) {
	const response = await makeApiRequest("/users/broker/reconnectbroker", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - REGENRATE  ACCOUNT KEY
export async function RegenerateAccountKey(values) {
	const response = await makeApiRequest("/users/broker/regeneratebrokerapikey", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - UPDATE ACCOUNT CALLBACK URL
export async function UpdateAccountCallbackUrl(values) {
	const response = await makeApiRequest("/users/broker/updatebrokercallbackurl", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - DELETE ACCOUNT
export async function DeleteAccount(values) {
	const response = await makeApiRequest("/users/broker/deletebroker", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - RENEW ACCOUNT
export async function RenewAccount(values) {
	const response = await makeApiRequest("/users/broker/renewbroker", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - REFRESH ACCOUNT
export async function RefreshAccount(values) {
	const response = await makeApiRequest("/users/broker/refreshbroker", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - REFRESH ACCOUNT DATA 
export async function FreshAccountData(values) {
	const response = await makeApiRequest("/users/broker/refreshaccountdata", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - SET ACCOUNT SL AND TP 
export async function SetAccountSLTP(values) {
	const response = await makeApiRequest("/users/broker/setslandtp", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - EXTEND ACCOUNT
export async function ExtendAccount(values) {
	const response = await makeApiRequest("/users/broker/extendbroker", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - UPDATE ACCOUNT TRADING STATUS
export async function UpdateAccountTradingStatus(values) {
	const response = await makeApiRequest("/users/broker/updatebrokertradingflag", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - UPDATE ACCOUNT AUTO RENEW
export async function UpdateAccountAutoRenew(values) {
	const response = await makeApiRequest("/users/broker/updatebrokerautorenew", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - GET ACCOUNT BY ID
export async function GetAccountById(values) {
	const response = await makeApiRequest("/users/broker/getbrokerbyid", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - PLACE ORDER
export async function PlaceOrder(values) {
	const response = await makeApiRequest("/users/broker/placeorder", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - GET ACCOUNT PENDING ORDER_HISTORY
export async function GetAccountPendingOrders(values) {
	const response = await makeApiRequest("/users/broker/getpendingorders", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - GET ACCOUNT POSITION
export async function GetAccountPositions(values) {
	const response = await makeApiRequest("/users/broker/getpositions", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - GET ACCOUNT TRADE HISTORY (direct from broker; type: positions | deals | orders | balance | summary)
// values: broker_id, start_date, end_date, symbol, position_id, limit, cursor (next_cursor of previous page)
export async function GetAccountTradeHistory(type, values) {
	const response = await makeApiRequest(`/users/broker/gethistory${type}`, values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}



// V1 - GET ACCOUNT HISTORICAL DATA
export async function GetAccountHistoricalData(values) {
	const response = await makeApiRequest("/users/broker/gethistoricaldealsdata", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - SQUARE OFF ACCOUNT POSITION
export async function SquareOffAccountPosition(values) {
	const response = await makeApiRequest("/users/broker/squareoff", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - SQUARE OFF ACCOUNT ALL POSITION
export async function SquareOffAllPositionsInAccount(values) {
	const response = await makeApiRequest("/users/broker/squareoffall", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - ACCOUNT ORDER CANCEl
export async function CancelAccountOrder(values) {
	const response = await makeApiRequest("/users/broker/cancelorder", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - ACCOUNT ORDER CANCEl ALL
export async function CancelAllOrdersInAccount(values) {
	const response = await makeApiRequest("/users/broker/cancelallorders", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - EDIT ACCOUNT ORDER
export async function EditOrderInAccount(values) {
	const response = await makeApiRequest("/users/broker/modifyorder", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//V1 - GET ACCOUNT QUEUE
export async function GetAccountQueue() {
	const response = await makeGetApiRequest("/users/broker/getbrokerqueue");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - GET ACCOUNT QUEUE BY ID
export async function GetAccountQueueById(values) {
	const response = await makeApiRequest("/users/broker/getbrokerqueuebyid", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - CANCEL ACCOUNT QUEUE
export async function CancelAccountQueue(values) {
	const response = await makeApiRequest("/users/broker/cancelbrokerqueue", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - DELETE ACCOUNT QUEUE
export async function DeleteAccountQueue(values) {
	const response = await makeApiRequest("/users/broker/removebrokerqueue", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - GET ACCOUNT SYMBOLS
export async function GetAccountSymbol(values) {
	const response = await makeApiRequest("/users/symbols/getbrokersymbols", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - UPDATE ACCOUNT SYMBOLS
export async function UpdateAccountSymbol(values) {
	const response = await makeApiRequest("/users/symbols/updatebrokersymbol", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - GET FX ACCOUNT SYMBOLS
export async function GetFxAccountSymbol(values) {
	const response = await makeApiRequest("/users/symbols/getfxbrokersymbols", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - COPY ACCOUNT SYMBOLS
export async function CopyAccountSymbol(values) {
	const response = await makeApiRequest("/users/symbols/copybrokersymbols", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - RESET ACCOUNT SYMBOLS
export async function ResetAccountSymbol(values) {
	const response = await makeApiRequest("/users/symbols/resetbrokersymbolmap", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//--------------------------------------------------------------GROUPS--------------------------------------------------------------
//V1 - GET GROUPS
export async function GetGroups() {
	const response = await makeGetApiRequest("/users/group/getgroups");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET GROUP NAMES
export async function GetGroupNames() {
	const response = await makeGetApiRequest("/users/group/getgroupnames");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - GET GROUP BY ID 
export async function GetGroupById(values) {
	const response = await makeApiRequest("/users/group/getgroupbyid", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - ADD GROUP
export async function AddGroup(values) {
	const response = await makeApiRequest("/users/group/addgroup", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}

}
// V1 - UPDATE GROUP NAME 
export async function UpdateGroupData(values) {
	const response = await makeApiRequest("/users/group/updategroupdata", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - CONNECT MASTER ACCOUNT
export async function ConnectMasterAccount(values) {
	const response = await makeApiRequest("/users/group/connectmaster", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - DISCONNECT MASTER ACCOUNT
export async function DisconnectMasterAccount(values) {
	const response = await makeApiRequest("/users/group/disconnectmaster", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - UPDATE GROUP TRADING STATUS
export async function UpdateGroupTradingStatus(values) {
	const response = await makeApiRequest("/users/group/updategrouptradingflag", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V1 - DELETE GROUP
export async function DeleteGroup(values) {
	const response = await makeApiRequest("/users/group/deletegroup", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - ADD GROUP CHILD ACCOUNT 
export async function AddGroupChildAccount(values) {
	const response = await makeApiRequest("/users/group/addgroupbroker", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - GET GROUP CHILD ACCOUNT DATA 
export async function GetGroupChildAccounts(values) {
	const response = await makeApiRequest("/users/group/getgroupbrokers", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V1 - DELETE CHILD ACCOUNT
export async function DeleteChildAccount(values) {
	const response = await makeApiRequest("/users/group/removegroupbroker", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - UPDATE CHILD  ACCOUNT TRADING STATUS
export async function UpdateChildAccountTradingStatus(values) {
	const response = await makeApiRequest("/users/group/updatechildtradingflag", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - UPDATE CHILD  ACCOUNT MULTIPLIER
export async function UpdateChildAccountMultiplier(values) {
	const response = await makeApiRequest("/users/group/updategroupbroker", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V1 - GROUP PLACE ORDER 
export async function GroupPlaceOrder(values) {
	const response = await makeApiRequest("/users/group/placegrouporder", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - GROUP ORDER CANCEl ALL
export async function CancelAllOrdersInGroup(values) {
	const response = await makeApiRequest("/users/group/cancelall", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - GROUP ORDER CANCEl 
export async function CancelOrdersInGroup(values) {
	const response = await makeApiRequest("/users/group/cancelorders", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V1 - SYNC GROUP BROKER BALANCE
export async function SyncGroupChildAccountBalance(values) {
	const response = await makeApiRequest("/users/group/syncgrpbrokersmultiplier", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - GROUP ORDER Edit
export async function EditOrdersInGroup(values) {
	const response = await makeApiRequest("/users/group/modifyorders", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - SQUARE OFF GROUp ALL POSITION
export async function SquareOffAllPositionsInGroup(values) {
	const response = await makeApiRequest("/users/group/squareoffall", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - GET GROUP USER POSITIONS
export async function GetGroupUserPositions(values) {
	const response = await makeApiRequest("/users/group/getgroupbrokerspositions", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - GET GROUP PENDING ORDER_HISTORY
export async function GetGroupPendingOrders(values) {
	const response = await makeApiRequest("/users/group/getgrouppendingorders", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET GROUP PENDING  ORDER USERS
export async function GetGroupPendingOrderUsers(values) {
	const response = await makeApiRequest("/users/group/getgrpuserpendingorders", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 - ATTACH TELEGRAM TO GROUP 
export async function AttachTelegramToGroup(values) {
	const response = await makeApiRequest("/users/group/attachtelegramtogroup", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1 REMOVE TELEGRAM FROM GROUP
export async function RemoveTelegramFromGroup(values) {
	const response = await makeApiRequest("/users/group/removetelegramfromgroup", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET TELEGRAM CHANNELS
export async function GetTelegramChannels() {
	const response = await makeGetApiRequest("/users/telegram/gettelegramchats");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//--------------------------------------------------------------PROFILE--------------------------------------------------------------
//V1 - GET COUNTRIES
export async function GetCountries() {
	const response = await makeGetApiRequest("/users/getcountries");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET PROFILES
export async function GetUserProfile() {
	const response = await makeGetApiRequest("/users/getuserprofile");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - UPDATE PROFILE
export async function UpdateUserProfile(values) {
	const response = await makeFormDataRequest("/users/updateuserprofile", values);
	if (response.status) {
		return response;
	} else {
		throw new Error(response.msg || "Unknown error. Please try again.");
	}

}
//V1 - UPDATE EMAIL
export async function UpdateUserEmail(values) {
	const response = await makeApiRequest("/users/updateuseremail", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - RESET PASSWORD
export async function ResetPassword(values) {
	const response = await makeApiRequest("/users/resetpassword", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - SET PREFERENCE
export async function SetPreference(values) {
	const response = await makeApiRequest("/users/setpreference", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//-------------------------------------------------------------- WALLET --------------------------------------------------------------
//V1 - GET USER WALLET
export async function GetWallet(values) {
	const response = await makeApiRequest("/users/getuserledger", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET USER WALLET
export async function GetINR(values) {
	const response = await makeApiRequest("/users/payment/getinr", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//-------------------------------------------------------------- CRYPTO PAYMENT (NOWPAYMENTS) --------------------------------------------------------------
//V1 - GET CRYPTO CURRENCIES & LIMITS
export async function GetCryptoCurrencies() {
	const response = await makeGetApiRequest("/users/nowpayments/getcurrencies");
	if (response.error) {
		throw new Error(response.error.message);
	}
	return response;
}
//V1 - CREATE CRYPTO PAYMENT
export async function CreateCryptoPayment(values) {
	const response = await makeApiRequest("/users/nowpayments/createpayment", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - REFRESH CRYPTO PAYMENT STATUS
export async function RefreshCryptoPayment(values) {
	const response = await makeApiRequest("/users/nowpayments/refreshpayment", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET CRYPTO PAYMENTS
export async function GetCryptoPayments(values) {
	const response = await makeApiRequest("/users/nowpayments/getpayments", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET CRYPTO PAYMENT BY ORDER ID
export async function GetCryptoPaymentById(values) {
	const response = await makeApiRequest("/users/nowpayments/getpaymentbyid", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//--------------------------------------------------------------ORDER HISTORY --------------------------------------------------------------
//V1 - GET GROUP ORDER HISTORY
export async function GetGroupOrderHistory(values) {
	const response = await makeApiRequest("/users/orderhistory/getgrouporderhistory", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET GROUP ORDER HISTORY
export async function GetIndividualOrderHistory(values) {
	const response = await makeApiRequest("/users/orderhistory/getindividualorderhistory", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET GROUP ORDER USERS
export async function GetGroupOrderUsers(values) {
	const response = await makeApiRequest("/users/orderhistory/getuserorders", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//-------------------------------------------------------------- ACTIVITY LOGS --------------------------------------------------------------
//V1 - GET USER ACTIVITYLOGS
export async function GetUserActivityLogs(values) {
	const response = await makeApiRequest("/users/getuseractivities", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//------------------------------------------------------------REFERRALS--------------------------------------------------------------------

//V1 - GET REFERRAL DATA 
export async function GetReferralData() {
	const response = await makeGetApiRequest("/users/referral/referraldata");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET ALL REFERRAL USERS 
export async function GetAllReferralUsers() {
	const response = await makeGetApiRequest("/users/referral/getallreferrals");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET ACTIVE REFERRAL USERS 
export async function GetActiveReferralUsers() {
	const response = await makeGetApiRequest("/users/referral/getactivereferrals");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET  REFERRAL EARNINGS 
export async function GetReferralEarnings() {
	const response = await makeGetApiRequest("/users/referral/getreferralearnings");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET CASHOUT LOGS
export async function GetCashoutLogs() {
	const response = await makeGetApiRequest("/users/referral/getcashoutreferrals");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//V1- REFERRAL CASHOUT REQUEST 
export async function ReferralCashoutRequest(values) {
	const response = await makeApiRequest("/users/referral/cashoutrequest", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1- UPDATE CASHOUT REQUEST
export async function UpdateCashoutRequest(values) {
	const response = await makeApiRequest("/users/referral/updatecashoutrequest", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//--------------------------------------------------------SEARCH SYMABOLS------------------------
//V1- SEARCH SYMBOLS
export async function SearchSymbols(values) {
	const response = await makeApiRequest("/symbols/searchsymbol", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//--------------------------------------------------------BRIDGE------------------------
//V1 - GET BRIDGE 
export async function GetBridge() {
	const response = await makeGetApiRequest("/users/bridge/getbridges");
	if (response.data) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET BRIDGE BY ID 
export async function GetBridgeById(values) {
	const response = await makeApiRequest("/users/bridge/getbridgebyid", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1- ADD BRIDGE 
export async function AddBridge(values) {
	const response = await makeApiRequest("/users/bridge/addbridge", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V1- UPDATE BRIDGE 
export async function UpdateBridge(values) {
	const response = await makeApiRequest("/users/bridge/updatebridge", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V1- UPDATE BRIDGE  TRADING FLAG
export async function UpdateBridgeTradingFlag(values) {
	const response = await makeApiRequest("/users/bridge/updatebridgetradingflag", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V1- DELETE BRIDGE 
export async function DeleteBridge(values) {
	const response = await makeApiRequest("/users/bridge/removebridge", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V1- CONNECT BRIDGE 
export async function ConnectBridge(values) {
	const response = await makeApiRequest("/users/bridge/connectbridge", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}


// V1- DISCONNECT BRIDGE 
export async function DisconnectBridge(values) {
	const response = await makeApiRequest("/users/bridge/disconnectbridge", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1- DISCONNECT BRIDGE 
export async function BridgePlaceOrder(values) {
	const response = await makeApiRequest("/users/bridge/placebridgeorder", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V1- REGENERATE BRIDGE KEY 
export async function RegenerateBridgeKey(values) {
	const response = await makeApiRequest("/users/bridge/regeneratebridgekey", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}


// V1- GET BRIDGE POSITIONS
export async function GetBridgePositions(values) {
	const response = await makeApiRequest("/users/bridge/getbridgepositions", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V1- GET BRIDGE SIGNALS
export async function GetBridgeSignals(values) {
	const response = await makeApiRequest("/users/bridge/getbridgesignals", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V1- TRADING VIEW SIMULATION
export async function TradingViewWebHookSimulation(json_bridge_id, json_bridge_key, payload) {
	const response = await makeApiRequest(`/users/bridge/webhook/tradingview/${json_bridge_id}/${json_bridge_key}`, payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//--------------------------------------------------------DASHBOARD------------------------
//V1 - DASHBOARD 
export async function GetDashboard() {
	const response = await makeGetApiRequest("/users/getdashboard");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//--------------------------------------------------------------CONFIGS--------------------------------------------------------------
//V1 - GET WHITE LABEL CONFIGS 
export async function GetWhiteLabelConfigs() {
	const response = await makeGetApiRequest("/users/whitelabelconfigs/getwhitelabelconfigs");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1- UPDATE WHITE LABEL CONFIGS
export async function UpdateWhiteLabelConfigs(values) {
	const response = await makeApiRequest("/users/whitelabelconfigs/updatewhitelabelconfigs", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET WHITE LABEL BANK DETAILS 
export async function GetWhiteLabelBankDetails() {
	const response = await makeGetApiRequest("/users/whitelabelconfigs/getwhitelabelbankdetails");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V1- UPDATE WHITE LABEL BANK DETAILS
export async function UpdateWhiteLabelBankDetails(values) {
	const response = await makeApiRequest("/users/whitelabelconfigs/updatewhitelabelbankdetails", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - GET WHITE LABEL FTP
export async function GetWhiteLabelFTP() {
	const response = await makeGetApiRequest("/users/whitelabelconfigs/getwhitellabelftp");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
// V1- UPDATE WHITE LABEL FTP
export async function UdpateWhiteLabelFTP(values) {
	const response = await makeApiRequest("/users/whitelabelconfigs/updatewhitellabelftp", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//V1 - UPDATE PROFILE
export async function UpdateWhiteLabelLogoImage(values) {
	const response = await makeFormDataRequest("/users/whitelabelconfigs/setwhitelabelimages", values);
	if (response.status) {
		return response;
	} else {
		throw new Error(response.msg || "Unknown error. Please try again.");
	}

}
//---------------------------------GROUP STRATEGY PALN---------------------------------------------

//V1 - GET GROUP STARTGEY PLAN
export async function GetGroupStrategyPlan(payload) {
	const response = await makeApiRequest("/users/strategies/getstrategyplans", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V1 - ADD GROUP STARTGEY PLAN
export async function AddGroupStrategyPlan(payload) {
	const response = await makeApiRequest("/users/strategies/addstrategyplan", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V1 - DELETE GROUP STARTEGY PLAN 
export async function DeleteGroupStrategyPlan(payload) {
	const response = await makeApiRequest("/users/strategies/deletestrategyplan", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}

//---------------------------------GROUP STRATEGY RECORD ---------------------------------------------
//V1 - GET GROUP STARTGEY RECORD
export async function GetGroupStrategyRecord(payload) {
	const response = await makeApiRequest("/users/strategies/getstrategyrecords", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V1 - ADD GROUP STARTGEY RECORD
export async function AddGroupStrategyRecord(payload) {
	const response = await makeApiRequest("/users/strategies/addstrategyrecord", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V1 -  UDPATE GROUP STRATEGT RECORD
export async function UpdateGroupStrategyRecord(payload) {
	const response = await makeApiRequest("/users/strategies/updatestrategyrecord", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V1 -  DELETE GROUP STRATEGT RECORD
export async function DeleteGroupStrategyRecord(payload) {
	const response = await makeApiRequest("/users/strategies/deletestrategyrecord", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//---------------------------------GROUP STRATEGY USER---------------------------------------------

//V1 - GET GROUP STARTGEY USERS
export async function GetGroupStrategyUsers(payload) {
	const response = await makeApiRequest("/users/strategies/getstrategyusers", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V1 - GET GROUP STARTGEY SUBSCRIPTIONS
export async function GetGroupStartegySubscriptions(payload) {
	const response = await makeApiRequest("/users/strategies/getstrategysubscriptioninfo", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}


//V1 - GET BROKER SUBSCRIPTION
export async function GetBrokerSubscriptions(payload) {
	const response = await makeApiRequest("/users/broker/getbrokerforsubscriptions", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}

//V1 - SUBSCRIBE USER STRATGEY
export async function SubscribeUserStrategy(payload) {
	const response = await makeApiRequest("/users/strategies/userstrategysubscription", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}

//V1 - UPDATE USER SUBSCRIPTIOn
export async function UpdateStrategySubscription(payload) {
	const response = await makeApiRequest("/users/strategies/updatestrategysubscription", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}


//V1 - UPDATE USER SUBSCRIPTIOn
export async function GetSubUserEmails(payload) {
	const response = await makeApiRequest("/users/strategies/getsubuseremails", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}

//V1 -  UPDATE STRATEGY PERMISSION
export async function UpdateStrategyPermission(payload) {
	const response = await makeApiRequest("/users/strategies/updatestrategypermission", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//---------------------------------USER MANAGEMENT---------------------------------------------
//V1 - GET SUB USER
export async function GetSubUsers(payload) {
	const response = await makeApiRequest("/users/subusermanager/getsubusers", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V1 - GET SUB USER INFO
export async function GetSubUserInfo(payload) {
	const response = await makeApiRequest("/users/subusermanager/getsubuserinfo", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}

//V1 -ADD SUB USER
export async function AddSubUser(payload) {
	const response = await makeApiRequest("/users/subusermanager/addsubuser", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}

//V1 - UPDATE REFERRAL PERCENT
export async function UpdateSubUserReferralPercent(payload) {
	const response = await makeApiRequest("/users/subusermanager/updatereferpercent", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}

//V1 - CREDIT DEBIT USER AMOUNT
export async function CreditDebitUserAmount(payload) {
	const response = await makeApiRequest("/users/subusermanager/creditdebitsubuser", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}

//V1 - SEND BULK MAILS
export async function SendBulkMails(payload) {
	const response = await makeApiRequest("/users/subusermanager/sendbulkmails", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}

//V1 - UPDATE USER PERMISSION
export async function UpdateUserPermission(payload) {
	const response = await makeApiRequest("/users/subusermanager/allowdisallowsettings", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V1 - ALLOW DISALLOW PRIVATE STARTEGY
export async function AllowDisallowPrivateStrategy(payload) {
	const response = await makeApiRequest("/users/strategies/allowdisallowprivatestrategies", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}

//V1 -  UPDATE SUB USER LABEL
export async function UpdateSubUserLabel(payload) {
	const response = await makeApiRequest("/users/subusermanager/updatesubuserlabel", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V1 - UPDATE ALL USER PERMISSION
export async function UpdateAllUserPermission(payload) {
	const response = await makeApiRequest("/users/subusermanager/updateallowsettings", payload);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		console.log(response.error);
		return { status: false, msg: response.error.message };
	} else {
		return { status: false, msg: "Unknown error. Please try again." };
	}
}
//V1- GET LINK USER BY ID 
export async function GetSubUserById(values) {
	const response = await makeApiRequest("/users/subusermanager/getsubuserinfo", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1- GET USERS ACCOUNTS 
export async function GetUserAccounts(values) {
	const response = await makeApiRequest("/users/broker/getWhiteLabelBrokers", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1- GET SUB USER SUBSCRIBED STRATEGY
export async function GetSubUserSubscribedStrategy(values) {
	const response = await makeApiRequest("/users/subusermanager/getsubscribedstrategies", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1- GET SUB USER WALLET
export async function GetSubUserWallet(values) {
	const response = await makeApiRequest("/users/subusermanager/getledger", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1- GET SUB USER ORDER_HISTORY
export async function GetSubUserOrderHistory(values) {
	const response = await makeApiRequest("/users/subusermanager/getorderhistory", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//V1- GET SUB USER REFERRAL
export async function GetSubUserReferral(values) {
	const response = await makeApiRequest("/users/subusermanager/getreferrals", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1- GET SUB USER ACTIVITY LOGS
export async function GetSubUserActivityLogs(values) {
	const response = await makeApiRequest("/users/subusermanager/getsubuseractivities", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

// V1 - ADD SUB USER ACCOUNT 
export async function AddSubUserAccount(values) {
	const response = await makeApiRequest("/users/broker/addsubuserbroker", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}


// V1 - REMOVE ALL SUB USER ACCOUNTS
export async function RemoveAllSubUserAccounts(values) {
	const response = await makeApiRequest("/users/broker/removesubuserbrokers", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//---------------------------------ORDER DETAILS--------------------------------------------
// V1 - GET ORDER DETAILS
export async function GetOrderDetails(values) {
	const response = await makeApiRequest("/users/orderhistory/getordershistory", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//---------------------------------TEHEM CONFIGRATION--------------------------------------------

//V1 - GET DEFAULT THEME 
export async function GetDefaultTheme() {
	const response = await makeGetApiRequest("/users/theme/getdefaulttheme");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}

//V1 - UPDATE THEME COLORS 
export async function UpdateThemeColors(values) {
	const response = await makeApiRequest("/users/theme/updatethemecolors", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - SET DEFAULT THEME 
export async function SetDefaultTheme(values) {
	const response = await makeApiRequest("/users/theme/setdefaulttheme", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//-------------------------------------TELEGRAM BOT-------------------------------------------

//V1 - GET TELEGRAM BOT 
export async function GetTelegramBot() {
	const response = await makeGetApiRequest("/users/telegram/gettelegrambot");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - ADD TELEGRAM BOT 
export async function AddTelegramBot(values) {
	const response = await makeApiRequest("/users/telegram/addtelegrambot", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - UPDATE  TELEGRAM BOT 
export async function UpdateTelegramBot(values) {
	const response = await makeApiRequest("/users/telegram/updatetelegrambot", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - DELETE   TELEGRAM BOT 
export async function DeleteTelegramBot(values) {
	const response = await makeApiRequest("/users/telegram/removetelegrambot", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - ADD TELEGRAM CHANNEL
export async function AddTelegramChannel(values) {
	const response = await makeApiRequest("/users/telegram/addtelegramchatconfig", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - UDPATE  TELEGRAM CHANNEL
export async function UpdateTelegramChannel(values) {
	const response = await makeApiRequest("/users/telegram/updatetelegramchatconfig", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - DELETE  TELEGRAM CHANNEL
export async function DeleteTelegramChannel(values) {
	const response = await makeApiRequest("/users/telegram/removetelegramchatconfig", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - SEND TELEGRAM MESSAGE
export async function SendTelegramMessage(values) {
	const response = await makeApiRequest("/users/telegram/sendtgmessage", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//-------------------------------------------------------------LABELS------------------------------------------------------------


//V1 - GET LABELS 
export async function GetLabels() {
	const response = await makeGetApiRequest("/users/whitelabelconfigs/getlabels");
	if (response) {
		return response;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - ADD LABEL
export async function AddLabel(values) {
	const response = await makeApiRequest("/users/whitelabelconfigs/addlabel", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - DELETE LABEL
export async function DeleteLabel(values) {
	const response = await makeApiRequest("/users/whitelabelconfigs/removelabel", values);
	if (response.result) {
		return response.result;
	} else if (response.error) {
		throw new Error(response.error.message);
	} else {
		throw new Error("Unknown error. Please try again.");
	}
}
//V1 - LABELIZED SUB USER
export async function LabelizedSubUser(values) {
	const response = await makeFormDataRequest("/users/whitelabelconfigs/labelizesubusers", values);
	if (response.status) {
		return response;
	} else {
		throw new Error(response.msg || "Unknown error. Please try again.");
	}

}